<template>
  <div class="drop-file">
    <div
      ref="wrapperRef"
      class="drop-file__input"
      :class="{
        'drop-file__input_error' : !!error,
        'drop-file__input_with-file' : !!titleDocument,
    }"
      :style="{
        height: `${height}px`,
    }"
      @dragenter="onDragEnter"
      @dragleave="onDragLeave"
      @drop="onDrop"
    >
      <div class="drop-file__label">
        <span
          class="drop-file__file-icon"
          v-if="titleDocument"
          v-html="iconDocument"
        />
        <div>{{ title }} <span v-if="!titleDocument">browse</span></div>
      </div>
      <input type="file" @change="onFileDrop"/>
    </div>
    <i
      v-if="titleDocument"
      class="icon-cross drop-file__remove-file"
      @click.stop="removeFileHandler"
    />
    <span
      v-if="error"
      class="drop-file__error-text"
    >
      {{error}}
    </span>
  </div>
</template>

<script>
import { DocumentIcon } from "../../../constants/icon";

export default {
  name: "UploadFiles",
  data() {
    return {
      iconDocument: DocumentIcon(),
    }
  },
  props: {
    titleDocument: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 55,
    },
    error: {
      type: String,
      default: '',
    },
  },
  computed: {
    title() {
      return this.titleDocument ? this.titleDocument : 'Drag & drop or'
    }
  },
  methods: {
    onDragEnter() {
      this.$refs.wrapperRef.classList.add('dragover');
    },
    onDragLeave() {
      this.$refs.wrapperRef.classList.remove('dragover');
    },
    onDrop() {
      this.$refs.wrapperRef.classList.remove('dragover');
    },
    onFileDrop(e) {
      this.$emit('downLoadFile', e.target.files[0]);
    },
    removeFileHandler() {
      this.$emit('removeFile');
    },
  },
}
</script>

<style scoped lang="scss">
@import "./src/sass/variables";

.drop-file {

  position: relative;

  &__input {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed $color-denim;
    position: relative;
    background-color: rgba($color-denim, 0.08);
    border-radius: 4px;
    overflow: hidden;

    &_with-file {
      background-color: transparent;
    }

    &_error {
      border-color: $color-pomegranate;
    }
  }


  &__error-text {
    position: absolute;
    left: 0;
    bottom: -17px;
    color: $color-pomegranate;
    font-size: 10px;
  }

  &.dragover {
    opacity: 0.6;
  }

  &__label {
    color: $color-gray;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    column-gap: 5px;
    padding: 0 35px 0 20px;

    span {
      color: $color-denim;
    }
  }

  input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    cursor: pointer;
    z-index: 2;
  }

  &__file-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateY(-2px);
  }

  &__remove-file {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    padding: 5px;
    color: $color-gray;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/UploadFiles/UploadFiles.vue